<template>
  <div>
    <Header />
    <el-tabs type="border-card">
      <el-tab-pane style="min-height: 93vh">
        <center>
          <el-button
            size="small"
            icon="el-icon-back"
            type="primary"
            style="margin-bottom: 15px"
            @click="back"
            >Regresar</el-button
          >
          <el-button icon="el-icon-refresh" type="info" @click="update" size="small"
            >Actualizar</el-button
          >
          <el-select
            size="small"
            v-model="type"
            placeholder="Seleccione una opción"
            style="margin-right: 20px; margin-left: 20px"
            @change="setData"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </center>
        <span slot="label">
          <i v-if="loading" class="el-icon-loading"></i> Total de Inventarios
        </span>
        <Dashboard :data="data_all" :tiempo="loading" />
      </el-tab-pane>
      <el-tab-pane style="min-height: 93vh" label="Reporte Flash">
        <WeekReport />
      </el-tab-pane>
      <el-tab-pane style="min-height: 93vh" label="Reportes Generales">
        <Reportes />
      </el-tab-pane>
      <el-tab-pane
        style="min-height: 93vh"
        label=" Riesgos con mayor presencia"
      >
        <TopTres />
      </el-tab-pane>
      <el-tab-pane
        style="min-height: 93vh"
        label="Reporte de Riesgos Personalizados"
      >
        <ReporteRiesgos />
      </el-tab-pane>
      <el-tab-pane style="min-height: 93vh" label="Reporte Gerencial">
        <ReporteGerencia />
      </el-tab-pane>
    </el-tabs>
    <Footer />
  </div>
</template>

<script>
import axios from "axios";
import Dashboard from "../components/Dashboard.vue";
import Footer from "../components/SupportFooterDashboard.vue";
import WeekReport from "../components/WeekReport.vue";
import TopTres from "../components/TopTres.vue";
import Reportes from "../components/Reportes.vue";
import ReporteRiesgos from "../components/ReporteRiesgos.vue";
import ReporteGerencia from "../components/ReporteGerencia.vue";
import Header from "../components/Header.vue";

export default {
  data() {
    return {
      type: "all",
      page_action: "",
      loading: false,
      data_all: [],
      data_propios: [],
      data_contratistas: [],
      options: [
        {
          value: "all",
          label: "Propios & Colaboradores",
        },
        {
          value: "propios",
          label: "Propios",
        },
        {
          value: "contratistas",
          label: "Colaboradores",
        },
      ],
    };
  },
  components: {
    Footer,
    Dashboard,
    WeekReport,
    Reportes,
    Header,
    TopTres,
    ReporteRiesgos,
    ReporteGerencia,
  },
  created() {
    if (JSON.stringify(this.$route.query) !== "{}") {
      localStorage.setItem("faena_dashboad", this.$route.query.faena);
    }
    this.getData(this.type);
  },
  methods: {
    setRisks() {
      this.$store.dispatch("updateData");
      this.getData(this.type);
    },
    setData(option) {
      this.$store.dispatch("updateData");
      this.getData(option);
    },
    update() {
      this.$store.dispatch("updateData");
      this.getData(this.type);
    },
    back() {
      this.$store.dispatch("updateData");
      window.history.go(-1);
    },
    getData(type) {
      if (!this.$store.getters.data_all) {
        this.loading = true;
        const self = this;
        axios
          .get(
            `/data-science/getDataDashboard/${localStorage.getItem(
              "faena_dashboad"
            )}/${type}`
          )
          .then((response) => {
            if (typeof response.data === "string") {
              self.getData("all");
            } else {
              self.data_all = response.data;
              self.$store.dispatch("setDataAll", response.data);
              self.loading = false;
            }
          })
          .catch((error) => {
            // handle error
            self.loading = false;
            console.log(error);
          });
      } else {
        this.data_all = this.$store.getters.data_all;
      }
    },
  },
};
</script>

<style scoped>
.font-table {
  font-size: 14px;
}
.intermitente {
  box-shadow: 0px 0px 20px;
  animation: infinite resplandorAnimation 2s;
}
@keyframes resplandorAnimation {
  0%,
  100% {
    box-shadow: 0px 0px 10px #ed7d31;
  }
  50% {
    box-shadow: 0px 0px 0px #ed7d31;
  }
}
</style>
